<template>
  <div>
    <div class="content">
      <div class="contentLeft">
        <div class="headCont">
          <Jiben v-if="jbShow" :info="info" @show="jbShowJs" />
          <div class="cont" v-if="!jbShow">
            <div class="img">
              <img :src="$imgUrl + info.member.avatars" />
            </div>
            <div class="box">
              <div class="nameBox">
                <div class="name">{{ info.memberinfo.realname }}</div>
                <div class="txt" @click="jbShow = true">编辑</div>
              </div>
              <div class="textBox">
                <div class="txt">{{ info.memberinfo.residence }}</div>
                <div class="shu"></div>
                <div class="txt">{{ info.memberinfo.education_cn }}</div>
                <div class="shu"></div>
                <div class="txt">{{ info.memberinfo.current_cn }}</div>
              </div>
              <div class="textBox">
                <div class="txt">{{ info.memberinfo.phone }}</div>
                <div class="shu"></div>
                <div class="txt">{{ info.memberinfo.weixin }}</div>
                <div class="shu"></div>
                <div class="txt">{{ info.memberinfo.email }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="contBox">
          <div class="box">
            <div class="name"><span style="color: red">*</span> 求职期望</div>
            <div class="yuan dis-cent" @click="qzAddClick">
              <div class="iconfont icon-add"></div>
            </div>
          </div>
          <Qiuzhi v-if="qzShow" :info="qzInfo" @show="qzShowJs" />
          <div class="cont" v-if="info_jobList.length != 0">
            <div class="nrCont" v-for="item in info_jobList">
              <div class="textBox">
                <div class="name">{{ item.intention_jobs }}</div>
                <div class="text">
                  {{ item.minprice }}k - {{ item.maxprice }}k x
                  {{ item.pricemonth }}薪
                </div>
                <div class="shu"></div>
                <div class="text">{{ item.district_cn }}</div>
                <div class="shu"></div>
                <div class="text">{{ item.trade_cn }}</div>
                <div class="bianji1 dis-cent">
                  <a-popconfirm
                    title="是否确定删除"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="scBjClick(item.id)"
                  >
                    删除
                  </a-popconfirm>
                </div>
                <div class="bianji dis-cent" @click="qzBjClick(item)">编辑</div>
              </div>
            </div>
          </div>
        </div>
        <div class="contBox">
          <div class="box">
            <div class="name">工作经历</div>
            <div class="yuan dis-cent" @click="gzAddClick">
              <div class="iconfont icon-add"></div>
            </div>
          </div>
          <Gongzuo v-if="gzShow" :info="gzInfo" @show="gzShowJs" />
          <div class="cont" v-if="experienceList.length != 0">
            <div class="gzCont" v-for="item in experienceList">
              <div class="titleBox">
                <div class="textBox">
                  <div class="name">{{ item.companyname }}</div>
                  <div class="time">
                    {{ item.start_time }}-{{ item.end_time }}
                  </div>
                </div>
                <div class="bianji1 dis-cent">
                  <a-popconfirm
                    title="是否确定删除"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="gzdelClick(item.id)"
                  >
                    删除
                  </a-popconfirm>
                </div>
                <div class="bianji dis-cent" @click="gzBjClick(item)">编辑</div>
              </div>
              <div class="text">{{ item.jobs }}</div>
              <div class="text">
                {{ item.achievements }}
              </div>
            </div>
          </div>
        </div>
        <div class="contBox">
          <div class="box">
            <div class="name">教育经历</div>
            <div class="yuan dis-cent" @click="jyAddClick">
              <div class="iconfont icon-add"></div>
            </div>
          </div>
          <Jiaoyu v-if="jyShow" :info="jyInfo" @show="jyShowJs" />
          <div class="cont" v-if="educationList.length != 0">
            <div class="gzCont" v-for="item in educationList">
              <div class="titleBox">
                <div class="textBox">
                  <div class="name">{{ item.school }}</div>
                  <div class="time">
                    {{ item.start_time }}-{{ item.end_time }}
                  </div>
                </div>
                <div class="bianji" @click="jyBjClick(item)">编辑</div>
              </div>
              <div class="txtBox">
                <div class="txt">{{ item.speciality }}</div>
                <div class="shu"></div>
                <div class="txt">{{ item.education_cn }}</div>
              </div>
              <div class="text">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>
        <div class="contBox">
          <div class="box">
            <div class="name">资格证书</div>
            <div class="yuan dis-cent" @click="zsAddClick">
              <div class="iconfont icon-add"></div>
            </div>
          </div>
          <Zhengshu v-if="zsShow" :info="zsInfo" @show="zsShowJs" />
          <div class="cont" v-if="certificateList.length != 0">
            <div class="zgCont" v-for="item in certificateList">
              <div class="img">
                <img :src="$imgUrl + item.resource" />
              </div>
              <div class="zgbox">
                <div class="name">{{ item.name }}</div>
                <div class="txt">{{ item.start_time }}</div>
              </div>
              <div class="bianji" @click="zsBjClick(item)">编辑</div>
            </div>
          </div>
        </div>
        <!-- <div class="contBox">
          <div class="box">
            <div class="name">优势亮点</div>
            <div class="yuan dis-cent" @click="ysShow = true">
              <div class="iconfont icon-add"></div>
            </div>
          </div>
          <Youshi v-if="ysShow" @show="ysShowJs" />
          <div v-if="!ysShow" class="youtext">
            编辑优势亮点，展示我的独特态度
          </div>
        </div> -->
      </div>
      <div class="contentRit">
        <div class="fjBox">
          <div class="titleBox">
            <div class="name">上传附件简历</div>
            <div class="textBox" @click="uploadFile">
              <div class="text">去上传</div>
              <div class="iconfont icon-enter"></div>
            </div>
          </div>
          <div class="jlList" v-if="info.memberinfo.resource">
            <a :href="$imgUrl + info.memberinfo.resource" download>
              <div class="jlLi">
                <div class="name">我的简历</div>
                <div class="text" @click.stop="jlPost('')">删除</div>
              </div>
            </a>
          </div>
          <div class="txt" v-if="!info.memberinfo.resource">
            在附件中展示更多优势与特长
          </div>
        </div>
        <div
          class="jlCont"
          v-if="
            jlNum != 0 ||
            experienceList.length == 0 ||
            educationList.length == 0 ||
            certificateList.length == 0 ||
            info_jobList.length == 0
          "
        >
          <div class="titleBox">
            <div class="name">简历待完善项</div>
            <div class="iconfont icon-tixingshixin tixingshixin"></div>
          </div>
          <div class="bzTxt">完善后获更强竟争力</div>
          <div class="qsBox" v-if="jlNum != 0">
            <div class="box">
              <div class="textBox">
                <div class="yuan"></div>
                <div class="text">基本信息</div>
              </div>
              <div class="txt">
                必填字段缺失 · <span>{{ jlNum }}项</span>
              </div>
            </div>
            <div class="bcBox">
              <div class="text">去补充</div>
              <div class="iconfont icon-enter"></div>
            </div>
          </div>
          <div class="qsBox" v-if="experienceList.length == 0">
            <div class="box">
              <div class="textBox">
                <div class="yuan"></div>
                <div class="text">工作经历</div>
              </div>
              <div class="txt">未填写</div>
            </div>
            <div class="bcBox">
              <div class="text">去补充</div>
              <div class="iconfont icon-enter"></div>
            </div>
          </div>
          <div class="qsBox" v-if="educationList.length == 0">
            <div class="box">
              <div class="textBox">
                <div class="yuan"></div>
                <div class="text">教育经历</div>
              </div>
              <div class="txt">未填写</div>
            </div>
            <div class="bcBox">
              <div class="text">去补充</div>
              <div class="iconfont icon-enter"></div>
            </div>
          </div>
          <div class="qsBox" v-if="certificateList.length == 0">
            <div class="box">
              <div class="textBox">
                <div class="yuan"></div>
                <div class="text">资格证书</div>
              </div>
              <div class="txt">未填写</div>
            </div>
            <div class="bcBox">
              <div class="text">去补充</div>
              <div class="iconfont icon-enter"></div>
            </div>
          </div>
          <div class="qsBox" v-if="info_jobList.length == 0">
            <div class="box">
              <div class="textBox">
                <div class="yuan"></div>
                <div class="text">求职期望</div>
              </div>
              <div class="txt">未填写</div>
            </div>
            <div class="bcBox">
              <div class="text">去补充</div>
              <div class="iconfont icon-enter"></div>
            </div>
          </div>
        </div>
        <div class="wzCont">
          <div class="titleBox">
            <div class="name">简历完整度</div>
          </div>
          <div class="jdBox">
            <div class="box">
              <div
                class="man"
                :style="'width:' + info.memberinfo.complete_percent + '%;'"
              ></div>
            </div>
            <div class="num">{{ info.memberinfo.complete_percent }}%</div>
          </div>
          <div class="text">持续优化简历 ，获更强职场竟争力</div>
        </div>
      </div>
    </div>
    <input
      type="file"
      ref="fileInput"
      @change="onFileChange"
      class="hide"
      accept=".doc,.docx,.wps"
    />
  </div>
</template>

<script>
import Gongzuo from "./gongzuo.vue";
import Jiaoyu from "./jiaoyu.vue";
import Jiben from "./jiben.vue";
import Qiuzhi from "./qiuzhi.vue";
import Youshi from "./youshi.vue";
import Zhengshu from "./zhengshu.vue";
import { Popconfirm, Modal } from "ant-design-vue";
export default {
  components: {
    Qiuzhi,
    Gongzuo,
    Youshi,
    Jiaoyu,
    Jiben,
    Zhengshu,
    "a-popconfirm": Popconfirm,
    "a-modal": Modal,
  },
  name: "",
  data() {
    return {
      jbShow: false,
      ysShow: false,
      gzShow: false,
      qzShow: false,
      jyShow: false,
      zsShow: false,
      info: {
        member: {},
        memberinfo: {},
      },
      gzInfo: {},
      experienceList: [],
      jyInfo: {},
      educationList: [],
      zsInfo: {},
      certificateList: [],
      qzInfo: {},
      info_jobList: [],
      jlInfo: {},
      jlNum: 0,
    };
  },
  created() {
    this.get();
    this.experienceGet();
    this.educationGet();
    this.certificateGet();
    this.info_jobGet();
  },
  methods: {
    uploadFile() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.jlPost(res.data.data.path_name);
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    jlPost(url) {
      this.$post("/nozzle/web/member_info_resource", {
        resource: url,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.get();
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    jbShowJs(data) {
      if (data) {
        this.get();
      }
      this.jbShow = false;
    },
    gzBjClick(item) {
      this.gzInfo = item;
      this.gzShow = true;
    },
    jyBjClick(item) {
      this.jyInfo = item;
      this.jyShow = true;
    },
    get() {
      this.$get("/nozzle/web/member_info").then((res) => {
        this.info = res;
        console.log(res);

        let jlNum = 0;
        if (!res.memberinfo.realname) {
          jlNum++;
        }
        if (!res.memberinfo.current_cn) {
          jlNum++;
        }
        if (!res.memberinfo.idcard) {
          jlNum++;
        }
        this.jlNum = jlNum;
      });
    },
    experienceGet() {
      this.$get("/nozzle/web/member_experience").then((res) => {
        if (res.data) {
          this.experienceList = res.data;
        }
      });
    },
    educationGet() {
      this.$get("/nozzle/web/member_education").then((res) => {
        if (res.data) {
          this.educationList = res.data;
        }
      });
    },
    certificateGet() {
      this.$get("/nozzle/web/member_certificate").then((res) => {
        if (res.data) {
          this.certificateList = res.data;
        }
      });
    },
    info_jobGet() {
      this.$get("/nozzle/web/member_info_job").then((res) => {
        console.log(res);
        if (res.data) {
          this.info_jobList = res.data;
        }
      });
    },
    // 求职模块
    qzShowJs(data) {
      this.qzShow = false;
      if (data) {
        this.info_jobGet();
        this.get();
      }
    },
    qzAddClick() {
      this.qzInfo = {};
      this.qzShow = true;
    },
    qzBjClick(data) {
      this.qzShow = true;
      this.qzInfo = data;
    },
    scBjClick(id) {
      this.$post("/common/delete", {
        id: id,
        table: "member_job",
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.info_jobGet();
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    // 工作模块
    gzdelClick(id) {
      this.$post("/common/delete", {
        id: id,
        table: "member_experience",
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.experienceGet();
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    gzShowJs(data) {
      this.gzShow = false;
      if (data) {
        this.experienceGet();
        this.get();
      }
    },
    gzAddClick() {
      this.gzShow = true;
      this.gzInfo = {};
    },
    // 优势模块
    ysShowJs() {
      this.ysShow = false;
    },
    ysAddClick() {
      this.ysShow = true;
    },
    // 教育
    jyShowJs(data) {
      this.jyShow = false;
      if (data) {
        this.educationGet();
        this.get();
      }
    },
    jyAddClick() {
      this.jyShow = true;
      this.jyInfo = {};
      if (this.certificateList.length >= 3) {
        this.$message.error("教育不能超过三个");
        return;
      }
    },
    zsBjClick(data) {
      this.zsShow = true;
      this.zsInfo = data;
    },
    // 证书
    zsShowJs(data) {
      this.zsShow = false;
      if (data) {
        this.certificateGet();
        this.get();
      }
    },
    zsAddClick() {
      this.zsShow = true;
      this.zsInfo = {};
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  display: flex;
  margin: auto;
  margin-top: 15px;
  width: 1280px;
  .contentLeft {
    width: calc(100% - 380px);
    .headCont {
      border-radius: 10px;
      background-color: #fff;
      overflow: hidden;
      .cont {
        padding: 20px 30px;
        display: flex;
        .img {
          width: 75px;
          height: 75px;
          border-radius: 50%;
        }
        .box {
          width: calc(100% - 75px);
          box-sizing: border-box;
          padding-left: 15px;
          .nameBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            .name {
              font-size: 20px;
              font-weight: 600;
            }
            .txt {
              color: #f51515;
              cursor: pointer;
            }
          }
          .textBox {
            display: flex;
            align-items: center;
            margin-top: 8px;
            color: #29354d;
            .shu {
              width: 1px;
              height: 15px;
              background-color: #ebebeb;
              margin: 0 15px;
            }
          }
        }
      }
      .ysCont {
        .box {
          padding: 0 30px 0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .name {
            font-size: 18px;
            font-weight: 600;
          }
          .yuan {
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background-color: #faeded;
            color: #f51515;
            .iconfont {
              font-weight: 600;
              cursor: pointer;
            }
          }
        }
        .text {
          padding: 0 30px 20px;
          margin-top: 15px;
          color: #9c9c9c;
          margin-bottom: 10px;
        }
      }
    }
    .contBox {
      border-radius: 10px;
      background-color: #fff;
      margin-top: 15px;
      padding-bottom: 10px;
      .youtext {
        padding: 0 30px 20px;
        margin-top: 15px;
        color: #9c9c9c;
        margin-bottom: 10px;
      }
      .box {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 20px 30px 10px;
        .name {
          font-size: 18px;
          font-weight: 600;
        }
        .yuan {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background-color: #faeded;
          color: #f51515;
          .iconfont {
            font-weight: 600;
            cursor: pointer;
          }
        }
      }
      .cont {
        padding: 0 15px 10px;
        .nrCont {
          padding: 15px 15px;
          border-radius: 10px;
          .textBox {
            display: flex;
            align-items: center;
            position: relative;
            .name {
              font-weight: 600;
              font-size: 15px;
              margin-right: 20px;
            }
            .text {
              color: #000;
              margin-right: 20px;
            }
            .shu {
              margin-right: 20px;
              position: relative;
              top: 1px;
              width: 2px;
              height: 14px;
              background-color: #9c9c9c;
            }
            .bianji {
              position: absolute;
              top: 0;
              right: 0;
              width: 50px;
              height: 100%;
              cursor: pointer;
              color: #f51515;
              display: none;
            }
            .bianji1 {
              position: absolute;
              top: 0;
              right: 50px;
              width: 50px;
              height: 100%;
              cursor: pointer;
              color: #f51515;
              display: none;
            }
          }
        }
        .nrCont:hover {
          background-color: #f1f5fc;
          .bianji {
            display: flex;
          }
          .bianji1 {
            display: flex;
          }
        }
        .gzCont {
          padding: 15px 15px;
          border-radius: 10px;
          .titleBox {
            display: flex;
            align-items: center;
            justify-content: space-between;
            position: relative;
            .textBox {
              display: flex;
              align-items: center;
              .name {
                font-weight: 600;
                margin-right: 15px;
              }
              .time {
                font-size: 13px;
              }
            }
            // .bianji {
            //   color: #f51515;
            //   cursor: pointer;
            //   display: none;
            // }
            .bianji {
              position: absolute;
              top: 0;
              right: 0;
              width: 50px;
              height: 100%;
              cursor: pointer;
              color: #f51515;
              display: none;
            }
            .bianji1 {
              position: absolute;
              top: 0;
              right: 50px;
              width: 50px;
              height: 100%;
              cursor: pointer;
              color: #f51515;
              display: none;
            }
          }
          .txtBox {
            display: flex;
            align-items: center;
            margin-top: 8px;
            .shu {
              height: 14px;
              width: 1px;
              background-color: #dddddd;
              margin: 0 15px;
            }
          }
          .text {
            margin-top: 8px;
            color: #2b3441;
          }
        }
        .gzCont:hover {
          background-color: #f1f5fc;
          .bianji {
            display: block;
          }
          .bianji1 {
            display: block;
          }
        }
        .zgCont {
          padding: 15px 15px;
          border-radius: 10px;
          display: flex;
          align-items: center;
          .img {
            width: 100px;
            height: 70px;
            border-radius: 5px;
            img {
              object-fit: cover;
            }
          }
          .zgbox {
            width: calc(100% - 200px);
            padding-left: 15px;
            box-sizing: border-box;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            height: 70px;
            .name {
              font-weight: 600;
              font-size: 16px;
            }
          }
          .bianji {
            width: 100px;
            color: #f51515;
            cursor: pointer;
            display: none;
            text-align: right;
          }
        }
        .zgCont:hover {
          background-color: #f1f5fc;
          .bianji {
            display: block;
          }
        }
      }
    }
  }
  .contentRit {
    width: 380px;
    padding-left: 15px;
    box-sizing: border-box;
    .fjBox {
      background-color: #fff;
      border-radius: 10px;
      padding: 18px 25px;
      margin-bottom: 15px;
      .titleBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          font-weight: 600;
          font-size: 16px;
        }
        .textBox {
          display: flex;
          align-items: center;
          cursor: pointer;
          .text {
            color: #f51515;
            font-weight: 500;
            font-size: 13px;
          }
          .iconfont {
            font-size: 12px;
            position: relative;
            top: 1px;
            font-weight: 500;
            color: #9c9c9c;
          }
        }
      }
      .txt {
        font-size: 12px;
        color: #666;
        margin-top: 10px;
      }
      .jlList {
        margin-top: 10px;
        .jlLi {
          display: flex;
          align-items: center;
          cursor: pointer;
          .name {
            width: calc(100% - 40px);
          }
          .text {
            width: 40px;
            text-align: right;
            font-size: 12px;
            color: #f51515;
            display: none;
          }
        }
        .jlLi:hover {
          .text {
            display: block;
          }
        }
      }
    }
    .jlCont {
      background-color: #fff;
      border-radius: 10px;
      padding: 18px 25px;
      margin-bottom: 15px;
      .titleBox {
        display: flex;
        align-items: center;
        .name {
          font-weight: 600;
          font-size: 16px;
          margin-right: 10px;
        }
        .tixingshixin {
          color: #f51515;
          font-size: 18px;
          position: relative;
          top: 1px;
        }
      }
      .bzTxt {
        color: #333;
        font-size: 12px;
        margin-top: 3px;
      }
      .qsBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 18px;
        .box {
          .textBox {
            display: flex;
            align-items: center;
            .yuan {
              background-color: #f51515;
              height: 8px;
              width: 8px;
              border-radius: 50%;
            }
            .text {
              font-weight: 600;
              margin-left: 5px;
            }
          }
          .txt {
            font-size: 12px;
            margin-top: 5px;
            padding-left: 13px;
            span {
              color: #f51515;
            }
          }
        }
        .bcBox {
          display: flex;
          align-items: center;
          cursor: pointer;
          .text {
            color: #f51515;
            font-weight: 500;
            font-size: 13px;
          }
          .iconfont {
            font-size: 12px;
            position: relative;
            top: 1px;
            font-weight: 500;
            color: #9c9c9c;
          }
        }
      }
    }
    .wzCont {
      background-color: #fff;
      border-radius: 10px;
      padding: 18px 25px;
      margin-bottom: 15px;
      .titleBox {
        display: flex;
        align-items: center;
        justify-content: space-between;
        .name {
          font-weight: 600;
          font-size: 16px;
          margin-right: 10px;
        }
        .texts {
          display: flex;
          align-items: center;
          color: #9c9c9c;
          cursor: pointer;
          .txt {
            font-size: 13px;
          }
          .iconfont {
            font-size: 12px;
          }
        }
      }
      .jdBox {
        display: flex;
        align-items: center;
        margin-top: 20px;
        .box {
          border-radius: 6px;
          height: 6px;
          width: calc(100% - 40px);
          background-color: #f1f1f1;
          position: relative;
          top: 1px;
          .man {
            width: 70%;
            background: linear-gradient(to right, #e01473, #f51515);
            border-radius: 6px;
            height: 100%;
          }
        }
        .num {
          font-size: 12px;
          color: #f51515;
          padding-left: 10px;
        }
      }
      .text {
        font-size: 12px;
        margin-top: 15px;
      }
    }
  }
}
</style>
